<template>
  <img class="vm-pic" :src="show_src" :alt="alt" />
</template>

<script>
export default {
  name: "btn",
  props: {
    src: {
      type: String,
      default: ""
    },
    alt: {
      type: String,
      default: ""
    },
    watermark_text: {
      type: String,
      default: ""
    },
    type: {
      type: [Number, String],
      default: 1
    },
    width: {
      type: [Number, String],
      default: 0
    },
    height: {
      type: [Number, String],
      default: 0
    },
    is_disable: {
      type: Boolean,
      default: false
    },
    is_show_origin: {
      type: Boolean,
      default: false
    },
    watermark: {
      type: [Number, String],
      default: 1
    },
    q: {
      type: [Number, String],
      default: ''
    },
  },
  data() {
    return {
      ratio: global.window ? window.devicePixelRatio : 1
    };
  },
  computed: {
    show_src() { //https://developer.qiniu.com/dora/api/basic-processing-images-imageview2
      let config = {
        src: this.src,
        width: this.width,
        height: this.height,
        type: this.type,
        is_show_origin: this.is_show_origin,
        watermark:this.watermark,
        watermark_text:this.watermark_text,
      }
      if(this.q){
        config.q = this.q
      }
      return this.$img_src(config);
      // var src = this.src;
      // if (this.is_show_origin || this.src.indexOf('imageMogr2') != -1 || this.src.indexOf('imageView2') != -1 || this.src.indexOf('blob') != -1){
      //     return src
      // }
      //
      // var size = this.ratio > 1 ? 2 : 1;
      // var w = '';
      // var h = '';
      // if (this.width > 0) {
      //     w = '/w/' + this.width * size;
      // }
      // if (this.width == 'screen') {
      //     w = '/w/' + document.body.clientWidth * size;
      // }
      //
      // if (this.height > 0) {
      //     h = '/h/' + this.height * size;
      // }
      // if (this.height == 'screen') {
      //     h = '/h/' + document.body.clientHeight * size;
      // }
      //
      // src = this.src + '?imageView2/' + this.type + w + h;
      // return src;
    }
  },
  mounted() {
    this.$el.onload = e => {
      this.$emit("loaded");
      this.$bus.$emit("IMG_LOADED", e);
    };
  },
  methods: {}
};
</script>

<style lang="stylus" scoped>
.vm-pic {
  &.circle {
    border-radius: 10000px;
  }
}
</style>
